module.exports = __webpack_public_path__ + "static/img/robotImg1.8fac319d.png";